import React, { MouseEvent } from 'react'
import * as S from './styles'

export type Props = {
  leftText: string
  rightText: string
  leftDisabled?: boolean
  rightDisabled?: boolean
  leftActive?: boolean
  rightActive?: boolean
  onClickLeft?: (e: MouseEvent) => void
  onClickRight?: (e: MouseEvent) => void
  style?: React.CSSProperties
  id?: string
}

export default function Divider({
  leftText,
  rightText,
  leftDisabled = false,
  rightDisabled = false,
  leftActive = false,
  rightActive = false,
  onClickLeft,
  onClickRight,
  ...props
}: Props) {
  return (
    <S.DividerContainer {...props}>
      <S.DividerWrapper>
        <S.DividerButton onClick={onClickLeft} disabled={leftDisabled} active={leftActive}>
          {leftText}
        </S.DividerButton>
      </S.DividerWrapper>
      <S.DividerWrapper>|</S.DividerWrapper>
      <S.DividerWrapper>
        <S.DividerButton onClick={onClickRight} disabled={rightDisabled} active={rightActive}>
          {rightText}
        </S.DividerButton>
      </S.DividerWrapper>
    </S.DividerContainer>
  )
}
